
        export default {"base":"components/SideBar/themes/base.js"};
    